package app.nestbridge.domain.identity.api.model

import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
data class UserProfileDto(
    val id: String,
    val userId: String,
    val fullName: String,
    val displayName: String,
    val profilePictureUrl: String? = null,
    val locale: String,
    val timezone: String,
    val createdAt: Instant,
    val createdBy: String,
    val modifiedAt: Instant,
    val modifiedBy: String,
)
